import { Sun } from 'lucide-react';

/**
 * "Summer Founding Partner" badge — shown on instructor cards/profiles
 * when the backend flag `is_summer_founding_partner` is set. Granted by
 * an admin and tied to the Summer 2026 promotion (free event posting
 * through Labor Day 2026).
 *
 * Visual: warm sunrise gradient (amber → coral → brand-purple) over
 * white, with a sun icon. Distinct from the cool teal/cyan/purple
 * Premium Instructor badge so the two can sit side-by-side without
 * visual clutter.
 */
export function SummerFoundingPartnerBadge({ size = 'md', className = '', 'data-testid': testId }) {
  const sizes = {
    sm: { pad: 'px-1.5 py-[3px]', text: 'text-[10px]', icon: 'w-2.5 h-2.5', border: 'p-[1px]' },
    md: { pad: 'px-2.5 py-1', text: 'text-[11px]', icon: 'w-3 h-3', border: 'p-[1.5px]' },
    lg: { pad: 'px-3 py-1.5', text: 'text-sm', icon: 'w-3.5 h-3.5', border: 'p-[1.5px]' },
  };
  const s = sizes[size] || sizes.md;
  // Warm sunrise gradient — kept inside the MFM family by routing the
  // last stop into our brand purple so it harmonises with Premium and
  // other accents on the page.
  const gradient = 'linear-gradient(135deg, #fbbf24, #f59e0b, #df5681, #b456df)';
  return (
    <span
      data-testid={testId || 'summer-founding-partner-badge'}
      title="Summer Founding Partner — supporting Meet For Mahjong's launch summer"
      className={`inline-block rounded-full ${s.border} ${className}`}
      style={{ backgroundImage: gradient }}
    >
      <span
        className={`flex items-center gap-1 rounded-full bg-white font-semibold tracking-wide uppercase ${s.pad} ${s.text}`}
      >
        <Sun className={s.icon} style={{ color: '#f59e0b' }} />
        <span className="bg-clip-text text-transparent" style={{ backgroundImage: gradient }}>
          Summer Founding Partner
        </span>
      </span>
    </span>
  );
}
